module.exports = __webpack_public_path__ + "assets/roboto-bold.e486328c17d1cc04d9496f9da34c5be2d44ceaab9cb04948e276ec972b0947c7.woff2";